/**
 * Hands the gold from a just-completed task to the list screen it navigates
 * back to, so it can show "+N gold". The hash router carries no state, so this
 * is a one-shot module-level slot: set before navigating, taken on mount.
 */
let pending: number | null = null;

export function setLastAward(gold: number): void {
  pending = gold > 0 ? gold : null;
}

export function takeLastAward(): number | null {
  const v = pending;
  pending = null;
  return v;
}

/**
 * A plain word for the board to show the same way, when there is no gold to show: "Task added"
 * after posting a task, "Moved to Done" after finishing one with bounties off. One-shot, as above.
 */
let pendingNotice: string | null = null;

export function setLastNotice(text: string): void {
  pendingNotice = text.trim() || null;
}

export function takeLastNotice(): string | null {
  const v = pendingNotice;
  pendingNotice = null;
  return v;
}
